import { CodeTypeModel }                from '../core/models/code-type';
import { InspectionTemplateGroupModel } from './models/inspection.template.group';
import { InspectionTemplateItemModel }  from './models/inspection.template.item';

export class InspectionTemplateGroup implements InspectionTemplateGroupModel {
  code          : string;
  description   : string;
  itemOrderings : Array<number>;
  items         : Array<InspectionTemplateItemModel>;
  itemsToDelete : Array<InspectionTemplateItemModel>;
  ordering      : number;
  types         : Array<CodeTypeModel>;

  constructor ( group : InspectionTemplateGroupModel, types : Array<CodeTypeModel> ) {


    this.types         = types;
    this.ordering      = group.ordering;
    this.itemOrderings = [];
    this.itemsToDelete = [];
    this.code          = group.code;
    this.description   = group.description;
    this.items         = this.initializeItems(group.items);

    this.resetOrderings();


  }

  initializeItems ( items : Array<InspectionTemplateItemModel> ) : Array<InspectionTemplateItemModel> {
    if (!items || !items.length) {
      return [
        {
          _destroy              : '0',
          comment               : null,
          description           : null,
          estimated_time_red    : null,
          estimated_time_yellow : null,
          group_ordering        : this.ordering,
          id                    : null,
          index                 : 0,
          inspection_group      : this.code,
          inspection_template_id: null,
          inspection_type       : null,
          ordering              : 1,
          product_id            : null,
          product_item_code     : null
        }
      ];
    }

    items.forEach(( item, index ) => {
      item.index = index;
    });

    return items;
  }

  resetOrderings () : void {
    this.itemOrderings = [];

    this.items.forEach(( _item : InspectionTemplateItemModel, index : number ) => {
      this.itemOrderings.push(index + 1);
    });
  }

  orderItems () : void {
    this.items.sort(( itemA : InspectionTemplateItemModel, itemB : InspectionTemplateItemModel ) => itemA.ordering - itemB.ordering);

    this.items.forEach(( item : InspectionTemplateItemModel, index : number ) => {
      item.ordering = index + 1;
    });
  }

  removeItem ( item : InspectionTemplateItemModel ) : void {
    const itemToDelete = this.items.splice((item.ordering - 1), 1)[0];

    itemToDelete._destroy = '1';

    this.itemsToDelete.push(itemToDelete);
    this.resetOrderings();
    this.orderItems();

    if (!this.items.length) {


      this.addItem();


      };


    }

  addItem () : void {
    const newestForm = this.items.length ? (this.items[this.items.length - 1] as any).form : {};

    if (newestForm && newestForm.$invalid) {


      newestForm.$setDirty();


      return;


    }

    this.items.push({
      group_ordering  : this.ordering,
      index           : this.items.length,
      inspection_group: this.code,
      ordering        : this.items.length + 1
    } as InspectionTemplateItemModel);

    this.itemOrderings.push(this.items.length);
  }

  reorderItem ( item : InspectionTemplateItemModel ) : void {
    const filteredItems = this.items.filter(( iteratedItem : InspectionTemplateItemModel ) => iteratedItem.index !== item.index);

    for (let i = 0; i < filteredItems.length; i++) {


      filteredItems[i].ordering++;


    }

    filteredItems.push(item);

    this.items = filteredItems;

    this.orderItems();
  }
}
